import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function usZipCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    const zipCodeRegex = /^\d{5}$|^\d{5}-\d{4}$/;

    const valid = zipCodeRegex.test(value);
    return valid ? null : { invalidUsZipCode: { value: control.value } };
  };
}

export function canadaZipCodeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    const zipCodeRegex = /^[a-zA-Z0-9]*$/;

    const valid = zipCodeRegex.test(value);
    return valid ? null : { invalidCanZipCode: { value: control.value } };
  };
}